import React from 'react'

export default function ProductDescription({ type, productId }) {
    return (
        <div>
            <div className="ml-3 mr-3 my-3 p-3 md:ml-0 bg-white rounded shadow pb-3">
                <div className="mx-3 mb-3">
                    <h1 className="text-2xl font-semibold text-gray-700 border-b border-gray-200">Description</h1>
                </div>
                <div className="m-3 mt-4">
                    <div className="text-lg">
                        <p>Welcome Buyers, this post is about Powertrac 445 PLUS Tractor, this tractor comes with all the advanced qualities. This post contains all the information about the tractor Powertrac 445 PLUS specifications, price, hp, engine and many more.</p>
                        
                        <br/><p>Powertrac 445 PLUS Tractor Engine Capacity ...</p>
                        <a>View more</a>
                    </div>
                </div>

            </div>
        </div>
    )
}
